import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { TABLE_HEADER_BACKGROUND_COLOR } from '../../../constants/colors';

interface Props {
  value: string,
  onChange: (newValue: string) => void
}

export default function TabShowOrderComponent({ value, onChange }: Props) {
  const {t}=useTranslation("global");
  return (
    <Box sx={{ width: '100%', backgroundColor: TABLE_HEADER_BACKGROUND_COLOR }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={(e: any, newValue: string) => {
          onChange(newValue)
        }} aria-label="basic tabs example" variant="scrollable"
          scrollButtons="auto">
          <Tab label={t("allReport_page.Show total Order")} value={"amount"} sx={{ textTransform: 'none' }} />
          <Tab label={t("allReport_page.Show total Amount")} value={"money"} sx={{ textTransform: 'none' }} />
        </Tabs>
      </Box>
    </Box>
  );
}
